import React from 'react';
import { MessageCircle } from 'lucide-react';

const FloatingWhatsAppButton = () => {
  return (
    <a 
      href="https://wa.me/919315982650" 
      target="_blank" 
      rel="noopener noreferrer"
      className="fixed bottom-28 right-8 z-40 bg-green-500 hover:bg-green-600 text-white px-5 py-4 rounded-full shadow-2xl flex items-center space-x-2 transition-all duration-300 hover:scale-110"
    >
      <MessageCircle className="w-6 h-6" fill="white" />
      <span className="font-semibold hidden sm:inline">WhatsApp</span>
    </a>
  );
};

export default FloatingWhatsAppButton;
